import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Chauffeurdrivenmercedence() {



  const cardData =
  {
    keyword: 'Chauffeur-Driven Mercedes Rentals in Mumbai',
    heading: 'Aaryan Travels: Chauffeur-Driven Mercedes Rentals in Mumbai',
    headingDescription: 'Aaryan Travels offers premium Chauffeur-Driven Mercedes Rentals in Mumbai for corporate executives, VIPs, wedding events, and luxury travelers who demand elegance, comfort, and professionalism. Whether you require a high-end ride for airport transfers from Chhatrapati Shivaji Maharaj International Airport, board meetings in BKC, or a grand wedding entry in South Mumbai, our Mercedes sedans with professional chauffeurs ensure a first-class travel experience. Featuring plush interiors, air suspension, and on-request amenities like Wi-Fi and bottled water, Aaryan Travels delivers a refined ride across Bandra, Andheri, Navi Mumbai, and Thane. For those who expect sophistication on every journey, our chauffeur-driven Mercedes rentals are the perfect choice.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 overlooking the Arabian Sea, is Mumbai’s most iconic monument. Originally constructed to welcome British royalty, it now serves as a bustling tourist hub. Visitors enjoy ferry rides to Elephanta Caves and panoramic sea views. Illuminated beautifully at night, it creates a majestic backdrop. Gateway of India is Mumbai’s grand symbol of pride and history."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace due to its crescent line of glowing lights at night, is a 3.6 km-long seaside promenade. Locals gather here for sunset walks, street snacks, and cool sea breeze. It’s a favorite place for contemplation and leisure. Marine Drive is Mumbai’s timeless stretch of peace and beauty."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST is a UNESCO-listed railway station built in 1887 in Victorian Gothic style. Its domes, stained-glass windows, and carvings make it look like a royal palace. Despite its heritage structure, it remains one of India’s busiest transport hubs. Lit up at night, it becomes a breathtaking sight. CST is Mumbai’s perfect blend of history and movement."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular sandy retreat, famous for its vibrant atmosphere and street food like pav bhaji and gola ice. Families enjoy camel rides while children play by the shore. Bollywood celebrities often reside nearby, adding glamour. Juhu Beach is Mumbai’s joyful seaside carnival."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb located on a small islet connected by a narrow walkway. During high tide, it appears to float in the sea. Devotees of all faiths visit to seek blessings and enjoy soulful qawwali music. Haji Ali is Mumbai’s serene island of spirituality."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these ancient rock-cut caves date back to the 5th century and feature intricate sculptures of Lord Shiva. The famous Trimurti statue is a highlight. A ferry ride from Gateway of India adds adventure and scenic beauty. Elephanta Caves are Mumbai’s masterpiece carved in stone."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Devotees, including celebrities and commoners, visit daily to seek blessings. The gold-plated dome and decorated idol radiate divine grace. Siddhivinayak is Mumbai’s powerful center of devotion."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed bridge offering spectacular views of the sea and skyline. Built with advanced engineering, it reduced travel time between the suburbs and South Mumbai. At night, its illuminated structure looks futuristic. The Sea Link is Mumbai’s symbol of modern progress."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a lively street market known for trendy clothes, jewelry, and souvenirs. Bargain hunters love exploring its colorful stalls. Legendary cafés like Leopold Café and Café Mondegar add vintage charm. Colaba Causeway is Mumbai’s vibrant shopping and culture lane."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests, offering safaris, trekking trails, and boating. The ancient Kanheri Caves inside the park add historical depth. Wildlife such as deer, monkeys, and exotic birds are commonly spotted. SGNP is Mumbai’s refreshing escape into nature."
  }
],



"services": [
  {
    "name": "Chauffeur-Driven Mercedes Rentals in Mumbai",
    "description": "Chauffeur-Driven Mercedes Rentals in Mumbai offer premium transportation solutions featuring luxury Mercedes vehicles with professional drivers. Designed for corporate executives, special events, and VIP clients, this service ensures superior comfort, punctuality, and a seamless travel experience. Clients benefit from personalized service, well-maintained cars, and drivers trained in corporate etiquette, making every journey both safe and elegant."
  },
  {
    "name": "Mercedes Car Hire with Driver Mumbai",
    "description": "Mercedes Car Hire with Driver Mumbai provides businesses and individuals access to a fleet of Mercedes-Benz vehicles driven by experienced chauffeurs. Whether for daily corporate travel, airport transfers, or leisure rides, this service guarantees timely pickups, courteous service, and a luxurious travel environment that reflects professionalism and class."
  },
  {
    "name": "Executive Mercedes Cab Mumbai",
    "description": "Executive Mercedes Cab Mumbai specializes in premium Mercedes cab services tailored for business leaders and professionals. Offering spacious interiors, privacy, and smooth rides, this service supports critical business travel needs, including meetings, client visits, and corporate events, ensuring a sophisticated and comfortable commute."
  },
  {
    "name": "Luxury Mercedes with Chauffeur Mumbai",
    "description": "Luxury Mercedes with Chauffeur Mumbai delivers an elite transportation experience with high-end Mercedes vehicles and skilled drivers. Ideal for VIPs, corporate events, and luxury travelers, the service focuses on discretion, personalized attention, and impeccable vehicle upkeep to provide a top-tier travel experience."
  },
  {
    "name": "Premium Mercedes Rental Mumbai",
    "description": "Premium Mercedes Rental Mumbai offers a wide selection of Mercedes-Benz cars for rent, paired with professional chauffeur services. The rental packages cater to both short and long-term needs, providing flexibility, reliability, and a luxurious way to travel around the city or for special occasions."
  },
  {
    "name": "Mercedes Benz Taxi Mumbai",
    "description": "Mercedes Benz Taxi Mumbai provides premium taxi services using a fleet of Mercedes vehicles. With professional drivers and efficient booking options, this service ensures timely, comfortable, and stylish transportation suitable for executives and discerning travelers across Mumbai."
  },
  {
    "name": "Corporate Mercedes Rentals Mumbai",
    "description": "Corporate Mercedes Rentals Mumbai deliver tailored rental solutions for companies requiring luxury transportation. The service includes chauffeur-driven Mercedes cars available on flexible plans to support employee commutes, client visits, and executive travel, ensuring high standards of professionalism and comfort."
  },
  {
    "name": "Mercedes SUV with Driver Mumbai",
    "description": "Mercedes SUV with Driver Mumbai offers spacious and elegant Mercedes SUVs for corporate and personal travel. Perfect for group transport, airport pickups, or VIP guest transfers, this service provides powerful vehicles combined with expert chauffeurs to deliver safety and luxury."
  },
  {
    "name": "Best Mercedes Chauffeur Service Mumbai",
    "description": "Best Mercedes Chauffeur Service Mumbai prides itself on exceptional service quality, featuring highly trained drivers and meticulously maintained Mercedes vehicles. The service guarantees punctuality, discretion, and a smooth travel experience for corporate clients, executives, and luxury travelers."
  },
  {
    "name": "Online Mercedes Booking Mumbai",
    "description": "Online Mercedes Booking Mumbai simplifies the reservation process by offering a user-friendly digital platform to book luxury Mercedes cars with chauffeurs. Clients can enjoy instant confirmations, easy cancellations, and real-time tracking, making premium travel more accessible and convenient."
  },
  {
    "name": "Affordable Mercedes Car Hire Mumbai",
    "description": "Affordable Mercedes Car Hire Mumbai combines luxury with cost-efficiency, offering competitively priced chauffeur-driven Mercedes vehicles. Ideal for startups, SMEs, and budget-conscious clients who desire a premium travel experience without compromising quality or service standards."
  },
  {
    "name": "Chauffeur Mercedes Mumbai",
    "description": "Chauffeur Mercedes Mumbai provides professional chauffeur services with a fleet of high-end Mercedes cars. The service is designed to cater to executives, VIPs, and corporate clients seeking reliable, safe, and stylish transportation throughout Mumbai."
  },
  {
    "name": "Mercedes Wedding Cab Mumbai",
    "description": "Mercedes Wedding Cab Mumbai specializes in luxury Mercedes vehicles for wedding ceremonies and related events. Offering elegant rides with professional chauffeurs, this service enhances special occasions by providing classy and comfortable transportation for the bride, groom, and guests."
  },
  {
    "name": "Elite Mercedes Cab Mumbai",
    "description": "Elite Mercedes Cab Mumbai delivers premium Mercedes-Benz transportation services that cater to clients demanding exclusivity and luxury. The fleet includes top-tier vehicles maintained to the highest standards, driven by courteous chauffeurs trained in etiquette and discretion."
  },
  {
    "name": "High-End Mercedes Hire Mumbai",
    "description": "High-End Mercedes Hire Mumbai offers exclusive rental options of luxury Mercedes cars for discerning clients. Whether for corporate travel, special events, or VIP transport, this service provides impeccable vehicles, skilled drivers, and a commitment to excellence in every ride."
  }
],
"tableData": [
  ["Chauffeur-Driven Mercedes Rentals in Mumbai", "Mercedes Car Hire with Driver Mumbai"],
  ["Executive Mercedes Cab Mumbai", "Luxury Mercedes with Chauffeur Mumbai"],
  ["Premium Mercedes Rental Mumbai", "Mercedes Benz Taxi Mumbai"],
  ["Corporate Mercedes Rentals Mumbai", "Mercedes SUV with Driver Mumbai"],
  ["Best Mercedes Chauffeur Service Mumbai", "Online Mercedes Booking Mumbai"],
  ["Affordable Mercedes Car Hire Mumbai", "Chauffeur Mercedes Mumbai"],
  ["Mercedes Wedding Cab Mumbai", "Elite Mercedes Cab Mumbai"],
  ["High-End Mercedes Hire Mumbai", "—"]
],



"whychoose": [
  {
    "WhyChooseheading": "Chauffeur-Driven Mercedes Rentals in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers luxurious chauffeur-driven Mercedes rentals in Mumbai, combining comfort and elegance for your travel needs."
  },
  {
    "WhyChooseheading": "Premium Mercedes Fleet",
    "WhyChoosedescription": "Select from our range of well-maintained Mercedes vehicles, ideal for corporate travel, special occasions, and airport transfers."
  },
  {
    "WhyChooseheading": "Professional and Courteous Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers provide punctual, discreet, and safe service to enhance your travel experience."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Vehicles",
    "WhyChoosedescription": "Each Mercedes vehicle is regularly sanitized and maintained to ensure hygiene and comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Benefit from all-inclusive rates covering fuel, tolls, and driver allowances with no surprise charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated team is available around the clock to assist with bookings and any travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Customize your chauffeur-driven Mercedes rental based on your schedule and requirements."
  },
  {
    "WhyChooseheading": "On-Time Service Across Mumbai",
    "WhyChoosedescription": "We ensure timely pickups and drop-offs anywhere in Mumbai, delivering a seamless luxury travel experience."
  }
]


























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer chauffeur-driven Mercedes rentals in Mumbai?',
    answer: 'Yes, Aaryan Travels provides luxury chauffeur-driven Mercedes rentals in Mumbai for business, events, and personal travel.',
  },
  {
    question: 'How can I book chauffeur-driven Mercedes rentals in Mumbai with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Mumbai.',
  },
  {
    question: 'What Mercedes models are available for chauffeur-driven rentals in Mumbai?',
    answer: 'Aaryan Travels offers a variety of Mercedes models including C-Class, E-Class, and S-Class with professional chauffeurs in Mumbai.',
  },
  {
    question: 'Are the chauffeurs experienced and trained for Mercedes rentals in Mumbai?',
    answer: 'Absolutely. Our chauffeurs are professionally trained, licensed, and committed to providing safe and comfortable rides.',
  },
  {
    question: 'Can I rent a chauffeur-driven Mercedes in Mumbai for short-term or long-term?',
    answer: 'Yes, Aaryan Travels offers flexible rental plans for chauffeur-driven Mercedes cars in Mumbai, including hourly, daily, and monthly options.',
  },
  {
    question: 'Is the chauffeur-driven Mercedes rental service available 24x7 in Mumbai?',
    answer: 'Yes, we provide 24x7 availability for chauffeur-driven Mercedes rentals in Mumbai to suit your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for chauffeur-driven Mercedes rentals in Mumbai?',
    answer: 'All Mercedes vehicles are sanitized regularly, and chauffeurs follow strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for chauffeur-driven Mercedes rentals in Mumbai?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the chauffeur-driven Mercedes rental period in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Karan Mehta',
    feedback: 'Aaryan Travels provided an exceptional chauffeur-driven Mercedes rental experience in Mumbai with professional and courteous chauffeurs.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patel',
    feedback: 'Highly recommend Aaryan Travels for chauffeur-driven Mercedes rentals in Mumbai. The service was luxurious and seamless.',
    rating: 5,
  },
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const chauffeurDrivenMercedesMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Chauffeur-Driven Mercedes Rentals in Mumbai",
  "description": "Aaryan Travels offers chauffeur-driven Mercedes rentals in Mumbai. Enjoy premium comfort, executive style, and professional chauffeurs for corporate travel, weddings, and luxury events.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "Chauffeur-Driven Mercedes Rentals",
  "keywords": "Chauffeur-Driven Mercedes Rentals in Mumbai, Mercedes Car Hire with Driver Mumbai, Executive Mercedes Cab Mumbai, Luxury Mercedes with Chauffeur Mumbai, Premium Mercedes Rental Mumbai, Mercedes Benz Taxi Mumbai, Corporate Mercedes Rentals Mumbai, Mercedes SUV with Driver Mumbai, Best Mercedes Chauffeur Service Mumbai, Online Mercedes Booking Mumbai, Affordable Mercedes Car Hire Mumbai, Chauffeur Mercedes Mumbai, Mercedes Wedding Cab Mumbai, Elite Mercedes Cab Mumbai, High-End Mercedes Hire Mumbai"
};








  return (
    <div>

<Helmet>
  <title>Chauffeur-Driven Mercedes Rentals in Mumbai | Luxury Mercedes Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Book chauffeur-driven Mercedes rentals in Mumbai with Aaryan Travels. Luxury Mercedes cars with professional chauffeurs for corporate travel, events, and weddings at affordable prices."
  />
  <meta
    name="keywords"
    content="Chauffeur-Driven Mercedes Rentals in Mumbai, Mercedes Car Hire with Driver Mumbai, Executive Mercedes Cab Mumbai, Luxury Mercedes with Chauffeur Mumbai, Premium Mercedes Rental Mumbai, Mercedes Benz Taxi Mumbai, Corporate Mercedes Rentals Mumbai, Mercedes SUV with Driver Mumbai, Best Mercedes Chauffeur Service Mumbai, Online Mercedes Booking Mumbai, Affordable Mercedes Car Hire Mumbai, Chauffeur Mercedes Mumbai, Mercedes Wedding Cab Mumbai, Elite Mercedes Cab Mumbai, High-End Mercedes Hire Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(chauffeurDrivenMercedesMumbaiSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Chauffeurdrivenmercedence;